import { createFileRoute, redirect } from "@tanstack/react-router";

import { WheelPrintView } from "~/components/wheel/results/print-view";
import { createNoIndexMeta } from "~/lib/shared/meta";

/** Printable coach results: the coach's name instead of the DCM header. */
export const Route = createFileRoute(
  "/$username/wheel-of-life/results/$id_/print",
)({
  loader: async ({ params }) => {
    const { getCoachWheelResultFn } = await import("~/lib/functions/wheel");
    const result = await getCoachWheelResultFn({
      data: { username: params.username, id: params.id },
    });
    if (result.kind === "platform") {
      throw redirect({
        to: "/wheel-of-life/results/$id/print",
        params: { id: params.id },
        statusCode: 302,
      });
    }
    return { page: result.page, session: result.session };
  },
  staticData: { title: "Wheel of Life — Print" },
  head: () =>
    createNoIndexMeta(
      "Wheel of Life — Print",
      "Printable view of your Wheel of Life results.",
    ),
  component: CoachPrintPage,
});

function CoachPrintPage(): React.JSX.Element {
  const { page, session } = Route.useLoaderData();
  const params = Route.useParams();
  return (
    <WheelPrintView
      id={params.id}
      session={session}
      header={`${page.coach.fullName} — wheel of life`}
      qrCaption="See your live results at"
      nextSteps={[]}
    />
  );
}
